import { TreeMenuComponent } from './tree-menu.component';
import { TreeMenuItemComponent } from './tree-menu-item.component';

export {
  TreeMenuComponent,
  TreeMenuItemComponent
};
